import { lazy, Suspense, useEffect, useState } from "react";
import { useQuery } from "react-query";

import { api, auth, cart } from "#/utils";
import { useLoading } from "#/utils/context/loading";
import { Footer } from "@monta/components";
import { Outlet, useLocation } from "@monta/router-react";
import styles from "./layout.module.scss";
import { HEADER_EXCEPTION_ROUTES } from "#/routes/route";

const Header = lazy(() =>
  import("@monta/components").then((module) => ({ default: module.Header }))
);

import type { IMenu } from "#/constants";

export const getMenuItems = async (userTypeId: number = 1) => {
  return api
    .get("/infrastructure/getMenu", {
      params: { b2c: true, userSubTypeId: userTypeId }
    })
    .then((res) => {
      return JSON.parse(res?.data?.landingMenu || "")?.linkList as IMenu[];
    })
    .catch(() => {
      return Promise.resolve([]);
    });
};

const Layout = () => {
  const [userTypeId, setUserTypeId] = useState<number>();
  const { showLoading, hideLoading } = useLoading();
  const loginInfo = auth.useAuth();
  const items = cart.useCartDetailedItems();
  const { data: menuItems } = useQuery(
    ["get-menu", userTypeId],
    () => {
      showLoading();
      return getMenuItems(userTypeId).finally(hideLoading);
    },
    {
      enabled: !!userTypeId,
      initialData: []
    }
  );

  const location = useLocation();

  useEffect(() => {
    if (loginInfo?.id) {
      setUserTypeId(loginInfo.subTypeId);
    }

    if (items && items.length > 0) {
      setUserTypeId(items[0].buyerTypeId);
    }
  }, [loginInfo, items]);

  const canShowHeader = !HEADER_EXCEPTION_ROUTES.includes(location.pathname);

  return (
    <div dir="rtl" id="app" className={styles["layout"]}>
      {canShowHeader ? (
        <Suspense fallback={null}>
          <Header
            api={api}
            auth={auth}
            cart={cart}
            menuItems={menuItems ?? []}
            route={location.pathname}
          />
        </Suspense>
      ) : null}

      <main>
        <Outlet />
      </main>

      {!auth.isLoggedIn && (
        <Footer
          auth={auth}
          userSubTypeId={loginInfo ? loginInfo.subTypeId : 1}
        />
      )}
    </div>
  );
};

export default Layout;
